import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const routes = {
    path: '',
    component: () =>
        import('../../../layouts/main/Main.vue'),
    children: [
        {

            path: '/general-requests',
            name: 'general-requests',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }
                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                if(hasPermission) next()
                else next('/forbidden')

            },
            component: () =>
                import('./PatientJourney/GeneralRequests/GeneralRequests.vue')
        },
        {

            path: '/dashboard-consultant',
            name: 'dashboard-consultant',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }
                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                if(hasPermission) next()
                else next('/forbidden')

            },
            component: () =>
                import('./DashboardMain/DashboardMain.vue')
        },
        {

            path: '/general-appointments',
            name: 'general-appointments',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }
                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                if(hasPermission) next()
                else next('/forbidden')

            },
            component: () =>
                import('./PatientJourney/GeneralAppointments/GeneralAppointments.vue')
        },
        {

            path: '/general-returns',
            name: 'general-returns',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }
                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                if(hasPermission) next()
                else next('/forbidden')

            },
            component: () =>
                import('./PatientJourney/GeneralReturns/GeneralReturns.vue')
        },
        {

            path: '/consultants-registered',
            name: 'consultants-registered',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./ConsultantsRegistered/ConsultantsRegistered.vue')
        },
        {

            path: '/divers',
            name: 'divers',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./Medicine/Divers/Divers.vue')
        },
        {

            path: '/medicine',
            name: 'medicine',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./Medicine/Medicine.vue')
        },
        {

            path: '/register-medicine',
            name: 'registerMedicine',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./Register/RegisterMedicine/RegisterMedicine.vue')
        },
        {

            path: '/customers',
            name: 'customers',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./Customer/Customers/Customers.vue')
        },
        {

            path: '/registration-data/:id/:fc',
            name: 'registration-data',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./Customer/RegistrationData/RegistrationData.vue')
        },
        {

            path: '/pharmacy',
            name: 'pharmacy',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./Medicine/Pharmacy/Pharmacy.vue')
        },
        {
            path: '/managed-match',
            name: 'managed-match',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./ManagedMatch/ManagedMatch.vue')
        },
        {
            path: '/register-specialty',
            name: 'register-specialty',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./Register/RegisterSpecialty/RegisterSpecialty.vue')
        },
        {
            path: '/register-exames',
            name: 'register-exames',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./Register/RegisterExames/RegisterExames.vue')
        },
        {
            path: '/associate-lab-exam',
            name: 'associate-lab-exam',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./Register/AssociateLabExam/AssociateLabExam.vue')
        },
        {
            path: '/register-parceiros',
            name: 'register-parceiros',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./Register/RegisterParceiros/RegisterParceiros.vue')
        },
        {
            path: '/register-laboratory',
            name: 'register-laboratory',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./Register/RegisterLaboratory/RegisterLaboratory.vue')
        },
        {
            path: '/register-marketplace-categoria',
            name: 'register-marketplace-categoria',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./Register/RegisterMarketplaceCategoria/RegisterMarketplaceCategoria.vue')
        },
        {
            path: '/register-marketplace-produto',
            name: 'register-marketplace-produto',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./Register/RegisterMarketplaceProduto/RegisterMarketplaceProduto.vue')
        },
        {
            path: '/laboratory-exams',
            name: 'laboratory-exams',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                }
                else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import ('./LaboratoryExams/LaboratoryExams.vue')
        },
        {
            path: '/laboratory-search',
            name: 'laboratory-search',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                }
                else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import ('./LaboratorySearch/LaboratorySearch.vue')
        },
        {
            path: '/emails',
            name: 'emails',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./Emails/Emails.vue')
        },
        {
            path: '/customer-report-attendance',
            name: 'customer-report-attendance',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./CustomerReport/CustomerReport.vue')
        },
        {

            path: '/analytical-consultation-of-schedules',
            name: 'analytical-consultation-of-schedules',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./AnalyticalConsultationOfSchedules/AnalyticalConsultationOfSchedules.vue')
        },
        {

            path: '/quicksight-attendance-dashboard',
            name: 'quicksight-attendance-dashboard',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault );
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                if(hasPermission) next()
                else next('/forbidden')

            },
            component: () =>
                import('./QuicksightConsultant/QuicksightConsultant.vue')
        },

    ]
}
export default [
    routes
]

